import React from "react";
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import { GrFormNextLink, GrFormPreviousLink } from "react-icons/gr";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";

const Pagination = ({ totalItems, page, totalPages, onPageChange }) => {
  const visibleRange = 2; // Show 2 pages before and after current page

  const renderPages = () => {
    const pages = [];
    const startPage = Math.max(1, page - visibleRange);
    const endPage = Math.min(totalPages, page + visibleRange);

    if (startPage > 1) {
      pages.push(
        <li className="page-item" key={1}>
          <button className="page-link" onClick={() => onPageChange(1)}>1</button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li className="page-item" key="start-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li className={`page-item ${i === page ? "active" : ""}`} key={i}>
          <button className="page-link" onClick={() => onPageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li className="page-item" key="end-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li className="page-item" key={totalPages}>
          <button className="page-link" onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  return (
    <div className={Style.alignPagging}>
      <h5>Total Items: {totalItems}</h5>
      <h5>Showing page {page} of {totalPages}</h5>
      <ul className={`${Button.flextCenterBtn} ${Style.pagging}`}>
        {page > 1 && (
          <>
            <li>
              <button type="button" onClick={() => onPageChange(1)}>
                <AiOutlineDoubleLeft className={Style.lastIcon} />
              </button>
            </li>
            <li>
              <button type="button" onClick={() => onPageChange(page - 1)}>
                <GrFormPreviousLink className={Style.lastIcon} />
              </button>
            </li>
          </>
        )}

        {renderPages()}

        {page < totalPages && (
          <>
            <li>
              <button type="button" onClick={() => onPageChange(page + 1)}>
                <GrFormNextLink className={Style.lastIcon} />
              </button>
            </li>
            <li>
              <button type="button" onClick={() => onPageChange(totalPages)}>
                <AiOutlineDoubleRight className={Style.lastIcon} />
              </button>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default Pagination;
